import { Grid } from '@mui/material';
import { useMainCustomStyle } from '../assets/theme/Theme';
import SideNavigationBar from './SideNavigationBar';

function MainGrid({ children }) {
	const mainDivStyle = useMainCustomStyle();

	return (
		<>
			<SideNavigationBar />
			<div style={mainDivStyle}>
				<Grid
					container
					paddingLeft={{ xs: '0px', md: '20px', sm: '20px' }}
					paddingRight={'20px'}>
					{children}
				</Grid>
			</div>
		</>
	);
}

export default MainGrid;
